"use client";
//#region packages/@mantine/core/src/components/Stack/Stack.module.css
var Stack_module_default = { "root": "m_6d731127" };
//#endregion
export { Stack_module_default as default };

//# sourceMappingURL=Stack.module.mjs.map